<template>

  <el-notification
    :notification="notification"
    :module="$t(`modules.process.${notification.data.data.content_type}.title`)"
    :date="notification.created_at"
    :title="$t(`modules.process.${notification.data.data.content_type}.notifications.submission_new`, { content: notification.data.data.content_name })"
  >
    <div slot="actions">
      <el-notification-button
        :notification="notification"
        :callback="goToContent"
        :title="$t(`modules.process.${notification.data.data.content_type}.notifications.btn_submission_new`)"
      />
    </div>
  </el-notification>

</template>

<script>

export default {
  tag: 'el-notification-process-submission_new',
  name: 'NotifProcessSubmissioNew',
  props: {
    notification: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    goToContent (notification) {
      return this.$router.push({name: notification.data.data.content_type + '.template.results', params: { world: this.world.id, template: notification.data.data.content_processtemplate }})
    },
  },
  computed: {
    world () {
      return this.$store.getters['auth/getWorld']
    },
  },
}
</script>

<style scoped lang="scss">

</style>
